function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFanduelLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92.26 92.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Homepage_Jorge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M46.55,92A92.16,92.16,0,0,0,92.26,12.78a.75.75,0,0,0-.38-.66A92,92,0,0,0,53.51.29a.8.8,0,0,0-.7.31,84.15,84.15,0,0,0-9.28,15.32.27.27,0,0,0,.25.39c.78,0,1.56,0,2.35,0A75.81,75.81,0,0,1,75.36,22.1,75.91,75.91,0,0,1,46.13,72.72a76.58,76.58,0,0,1-9-8.08.27.27,0,0,0-.46.22,83.42,83.42,0,0,0,9.21,27A.48.48,0,0,0,46.55,92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.22,56.21a75.36,75.36,0,0,1-5-8.1,47.91,47.91,0,0,1,4.68-1.93.79.79,0,0,0,.52-.68,89.06,89.06,0,0,1,2.71-16.68.26.26,0,0,0-.31-.32A64.75,64.75,0,0,0,19.12,33,75.17,75.17,0,0,1,16.9,22.1a75.66,75.66,0,0,1,19.89-5.26.72.72,0,0,0,.57-.42,91.58,91.58,0,0,1,8.89-16,.25.25,0,0,0-.2-.39A91.79,91.79,0,0,0,.41,12.1a.81.81,0,0,0-.41.71c0,28.93,14.42,56.25,36.46,73a.27.27,0,0,0,.41-.32,89.11,89.11,0,0,1-6.53-28.94A.67.67,0,0,0,30.22,56.21Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFanduelLogo);
export default __webpack_public_path__ + "static/media/fanduel-logo.6d40640dd1f5a849a6fe354079dbdf85.svg";
export { ForwardRef as ReactComponent };